import { InventoryItemManifestJson } from '../../API/InventoryItemJson'
import InventoryItemDetailsBox from '../../Containers/InventoryItemDetailsBox/InventoryItemDetailsBox'
import LabelContainer from '../../Containers/LabelContainer/LabelContainer'
import AudioController from '../../Controllers/AudioController'
import InventoryCombinationsController from '../../Controllers/InventoryCombinationsController'
import Image from '../Image'

export type InventoryItemManifest = {
    id: string
    thumbnailImage: Image
    infoText: string
    infoAudioId: string
    label: string
    detailImage: Image
    detailText: string
    detailAudioId: string
}

export default class InventoryItem {
    id: string
    element = document.createElement('div')

    label: string
    infoText: string
    thumbnailImage: Image
    infoAudioId: string

    detailText: string
    detailImage: Image
    detailAudioId: string

    constructor(manifest: InventoryItemManifestJson) {
        this.id = manifest.id
        this.label = manifest.label
        this.infoText = manifest.infoText
        this.thumbnailImage = new Image(manifest.thumbnailURL)
        this.infoAudioId = AudioController.add(manifest.infoAudioURL)
        this.detailText = manifest.detailText
        this.detailImage = new Image(manifest.detailImageURL)
        this.detailAudioId = AudioController.add(manifest.detailAudioURL)

        this.element.id = manifest.id
        this.element.classList.add('inventory-item')
        this.element.appendChild(this.thumbnailImage.element)

        // element mouse events
        this.element.onmouseover = this.handleMouseOver
        this.element.onmouseout = this.handleMouseOut
        this.element.onclick = this.handleClick
        this.element.oncontextmenu = this.handleContextMenu

        // element drag&drop
        this.element.draggable = true
        this.element.ondragenter = this.handleDragEnter
        this.element.ondragleave = this.handleDragLeave
        this.element.ondragover = this.handleDragOver
        this.element.ondrop = this.handleDrop
        this.element.ondragstart = this.handleDragStart
    }

    load = async () => {
        // TODO: How should we handle missing images?
        // Fail hard or just fail _loud_?
        try {
            await this.detailImage.load()
            await this.thumbnailImage.load()
        } catch (e) {
            console.error(e)
        }
    }

    remove = () => {
        this.element.remove()
    }

    destroy = () => {
        this.element.remove()
        this.remove()
        AudioController.remove(this.infoAudioId)
        AudioController.remove(this.detailAudioId)
        this.detailImage.destroy()
        this.thumbnailImage.destroy()
    }

    handleMouseOver = () => {
        LabelContainer.setText(this.label)
    }

    handleMouseOut = () => {
        LabelContainer.clear()
        this.element.classList.remove('newly-added')
    }

    handleClick = async () => {
        if (this.detailImage) {
            InventoryItemDetailsBox.setImage(this.detailImage)
            InventoryItemDetailsBox.show()
        }
        // TODO: use delay to show text even if audio is missing
        if (this.infoAudioId) {
            await AudioController.playActionAudio(this.infoAudioId, this.infoText)
        }
    }

    handleContextMenu = async () => {
        if (this.detailAudioId) {
            await AudioController.playActionAudio(this.detailAudioId, this.detailText)
        }
    }

    handleDragEnter = () => {
        // TODO: rename class '--hovered'
        this.element.classList.add('over')
    }

    handleDragLeave = () => {
        this.element.classList.remove('over')
    }

    handleDragOver = (e: DragEvent) => {
        e.preventDefault()

        if (e.dataTransfer) {
            e.dataTransfer.dropEffect = 'move'
        }

        return false
    }

    handleDrop = (e: DragEvent) => {
        // WHY: see drag event docs on MDN
        e.preventDefault()
        e.stopPropagation()

        this.element.classList.remove('over')

        const droppedItemId = e.dataTransfer?.getData('text/plain') as string

        if (droppedItemId !== this.id) {
            InventoryCombinationsController.combine(droppedItemId, this.id)
        }

        // WHY: see drag event docs on MDN
        // prevent event propagation
        return false
    }

    handleDragStart = (e: DragEvent) => {
        e.dataTransfer?.setDragImage(this.thumbnailImage.element, 0, 0)
        if (e.dataTransfer) {
            e.dataTransfer.effectAllowed = 'move'
            e.dataTransfer.setData('text/plain', this.id)
        }
    }
}
